import { CategoryLayout } from "@features/layout";

export const CategoriesPage = () => {
  return <CategoryLayout />;
};
